// Authentication constants
export const AUTH_TYPES = {
  EDS: 'eds',
  ADMIN: 'admin',
  CLIENT: 'client',
};

export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  OPERATOR: 'operator',
};

export const AUTH_ROUTES = {
  LOGIN: '/auth/user',
  ADMIN_LOGIN: '/auth/admin',
  DASHBOARD: '/dashboard/all-applications',
  CALL_CENTER: '/callCenter/allClients',
  USER_SUBMISSIONS: '/app/submissions',
};

export const DEFAULT_ADMIN_CREDENTIALS = {
  email: 'admin@localhost.com',
  password: '12345678',
  showPassword: false,
};

export const DEFAULT_CLIENT_CREDENTIALS = {
  TIN: '783518913',
  contractId: 'CONTRACT-6131AB',
  alias: '',
};

export const EDS_TIMEOUTS = {
  SEARCH_KEY: 3000,
  AUTH_DELAY: 1000,
  SUCCESS_DELAY: 1500,
};

export const SNACKBAR_CONFIG = {
  POSITION: {
    vertical: 'top',
    horizontal: 'left',
  },
};
